import React from 'react';
import {
  FaCoins, FaTrophy, FaDiscord,
  FaShieldAlt, FaLock, FaHeadset, FaBook
} from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

const Footer = () => {
  const navigate = useNavigate();

  const handleSupportClick = (e) => {
    e.preventDefault();
    if (window.Tawk_API && window.Tawk_API.maximize) {
      window.Tawk_API.maximize();
    }
  };

  const handleTabLink = (e, tab) => {
    e.preventDefault();
    navigate(`/dashboard?tab=${tab}`);
  };

  return (
    <footer className="site-footer">
      <div className="footer-content">
        <div className="footer-section">
          <h3>Game Modes</h3>
          <div className="footer-links-grid">
            <a href="/coinflip" className="footer-link-card">
              <FaCoins className="link-icon coin" />
              <span>Coinflip</span>
            </a>
            <a href="/jackpot" className="footer-link-card">
              <FaTrophy className="link-icon trophy" />
              <span>Jackpot</span>
            </a>
          </div>
        </div>

        <div className="footer-section">
          <h3>Support</h3>
          <div className="footer-links-grid">
            <a href="#" onClick={handleSupportClick} className="footer-link-card support-live">
              <div className="live-indicator">
                <span className="dot pulse"></span>
              </div>
              <FaHeadset className="link-icon" />
              <span>Live Support</span>
            </a>
            <a href="#" onClick={(e) => handleTabLink(e, 'tos')} className="footer-link-card">
              <FaBook className="link-icon" />
              <span>Terms of Service</span>
            </a>
            <a href="#" onClick={(e) => handleTabLink(e, 'privacy')} className="footer-link-card">
              <FaShieldAlt className="link-icon" />
              <span>Privacy Policy</span>
            </a>
          </div>
        </div>

        <div className="footer-section">
          <h3>Security & Trust</h3>
          <div className="trust-badges-grid">
            <div className="trust-badge-card" title="Provably Fair">
              <FaShieldAlt style={{ color: '#ffb703' }} />
              <div className="trust-text">
                <span className="badge-title">Provably Fair</span>
                <span className="badge-desc">Verifiable provably Fair System</span>
              </div>
            </div>
            <div className="trust-badge-card" title="SSL Encrypted">
              <FaLock style={{ color: '#4ade80' }} />
              <div className="trust-text">
                <span className="badge-title">SSL Secure</span>
                <span className="badge-desc">Bank-grade encryption</span>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-section">
          <h3>Accepted Crypto</h3>
          <div className="payment-methods-grid-premium">
            <div className="payment-method-glass" title="Bitcoin">
              <FaCoins style={{ color: '#F7931A' }} />
              <span>BTC</span>
            </div>
            <div className="payment-method-glass" title="Ethereum">
              <FaCoins style={{ color: '#627EEA' }} />
              <span>ETH</span>
            </div>
            <div className="payment-method-glass" title="Litecoin">
              <FaCoins style={{ color: '#345D9D' }} />
              <span>LTC</span>
            </div>
            <div className="payment-method-glass" title="Tether">
              <FaCoins style={{ color: '#26A17B' }} />
              <span>USDT</span>
            </div>
          </div>
        </div>

        <div className="footer-section">
          <h3>Community</h3>
          <div className="social-links-modern">
            <a href="https://discord.gg/7dayErEGt7" target="_blank" rel="noopener noreferrer" className="social-link-btn discord">
              <FaDiscord />
            </a>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        &copy; {new Date().getFullYear()} RustyCoin. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;

